/* Emițătorul pentru experimentul sticky ATC, descrierea bogată și clicurile pe WhatsApp.
 *
 * SURSA UNICĂ e acest fișier. Se copiază identic ca `assets/am-interactiuni-tracking.js` în tema
 * DEV și se include din `theme.liquid`, după `am-collection-tracking.js`.
 *
 * DE CE (13.10.2026, audit-date-romania §C2): tema împinge în `window.dataLayer` alocarea
 * experimentului (`am_exp_assign`), vizibilitatea barei (`am_sticky_atc_view`), încercările și
 * adăugările confirmate (`am_atc_attempt` / `am_atc_source`) și interacțiunile din descrierea
 * bogată (`am_rich_*`). Containerul GTM n-are nicio regulă pentru ele, nu există gtag în pagină,
 * iar Simprosys are `gtm_enabled 0` → ZERO rânduri în BigQuery din 27.08. Instrumentarea „măsura"
 * doar în pagină.
 *
 * CE FACE: duce aceleași evenimente pe CALEA care funcționează deja pentru meniu și colecții —
 * `Shopify.analytics.publish('audio_monkey:…')` → pixelul propriu (`ascultator-pixel.js`) →
 * proxy-ul MP din Worker (schemă per eveniment) → GA4. Nu atinge snippeturile care produc
 * evenimentele (`am-cro-experiment`, `am-cro-sticky-instrumentare`, `rich-description`): logica
 * lor (observatori de vizibilitate, confirmarea pe corpul răspunsului `/cart/add`) rămâne una
 * singură; aici doar le ascultăm.
 *
 * CUM ASCULTĂM `dataLayer`: învelim `dataLayer.push`. GTM face exact același lucru și ÎNLĂNȚUIE
 * funcția existentă (`var e=c.push; c.push=function(){…e.apply(c,h)…}`, citit în gtm.js servit pe
 * 13.10), deci ordinea de încărcare GTM/noi nu contează. Intrările împinse ÎNAINTE de noi
 * (snippetul experimentului rulează în <head>) se citesc o dată, la pornire.
 *
 * ALOCAREA se publică la fiecare încărcare de pagină; pixelul o trimite O DATĂ per (client,
 * sesiune GA4) și numai după ce a trimis-o efectiv — o deduplicare aici, înaintea
 * consimțământului, ar pierde sesiunea vizitatorului care acceptă bannerul pe pagina a doua.
 *
 * WHATSAPP: ascultător delegat pe TOATE linkurile/butoanele `wa.me` (antet/subsol, carduri,
 * PDP, bara sticky, descrierea bogată, căutare, panoul openbox), cu suprafața dedusă din
 * container. `am_rich_whatsapp_click` din dataLayer NU se mai duce separat — ar dubla clicul din
 * descriere. Eveniment propriu `am_whatsapp_click`, NU `generate_lead`: un clic deschide
 * aplicația, nu dovedește un mesaj trimis; `generate_lead` e eveniment recomandat de conversie,
 * iar pixelul ăsta nu trimite conversii (antetul `ascultator-pixel.js`). Promovarea la key event
 * rămâne o decizie explicită în GA4.
 *
 * NICIO DATĂ PERSONALĂ: brațul (a/b), sursa butonului, tipul interacțiunii, ancora din descriere,
 * calea unui link intern, id-ul unui video YouTube, întrebarea dintr-un FAQ (text editorial, nu
 * scris de client). Textul mesajului WhatsApp (care conține numele produsului și, în panoul de
 * callback, numele și telefonul clientului) NU se citește niciodată.
 */
(function () {
  'use strict';

  if (window.__amInteractiuniTracking) return;   // inclus de două ori = evenimente dublate
  window.__amInteractiuniTracking = true;

  var BRATE = { a: 1, b: 1 };
  var SURSE_ATC = { sticky: 1, principal: 1, openbox: 1, recomandare: 1, necunoscut: 1 };

  function publica(nume, d) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('audio_monkey:' + nume, d);
      }
    } catch (err) { /* măsurarea nu are voie să strice pagina */ }
  }

  function brat(v) { return BRATE[v] ? v : 'nealocat'; }

  /* Același alfabet ca în proxy (`schemaRich`): ce nu trece devine spațiu, ca un „?" sau un „–"
   * dintr-o întrebare să nu ducă la respingerea întregului eveniment. */
  var NEPERMIS_TEXT = /[^\p{L}\p{N} &\/.,'’"()+!?:%°×–-]/gu;
  function textCurat(t, max) {
    t = String(t || '');
    if (t.normalize) t = t.normalize('NFC');
    return t.replace(NEPERMIS_TEXT, ' ').replace(/\s+/g, ' ').trim().slice(0, max).trim();
  }

  /* Calea unui link INTERN, fără query/fragment; extern sau neparsabil → null. */
  function caleInterna(href) {
    try {
      var u = new URL(String(href || ''), location.href);
      if (!/(^|\.)audiomonkey\.(ro|bg)$/.test(u.hostname)) return null;
      return /^\/[a-z0-9\-\/_.]{0,120}$/.test(u.pathname) ? u.pathname : null;
    } catch (err) { return null; }
  }

  // ─── dataLayer → evenimente custom ──────────────────────────────────────────
  /* Fiecare intrare dataLayer cunoscută devine UN eveniment custom; restul se ignoră.
   * `am_sticky_atc_click` NU se duce: e identic cu `am_atc_attempt` cu `sursa: sticky`, emis la
   * același clic — două cereri pentru o informație. `am_exp_assign` se tratează separat (mai jos). */
  var HARTA = {
    am_sticky_atc_view: function (o) { publica('sticky_atc_view', { brat: brat(o.am_exp_sticky) }); },
    am_atc_attempt: function (o) { atc('incercare', o); },
    am_atc_source: function (o) { atc('confirmat', o); },
    /* Video-ul din hero pornește SINGUR (`autoplay`, pus de `rich-description` dacă vizitatorul
     * nu cere mișcare redusă), iar snippetul îi atașează același ascultător `play` — fără filtrul
     * de aici fiecare PDP cu hero video ar raporta o „redare" pe care n-a cerut-o nimeni. */
    am_rich_video_play: function (o) {
      var i = Number(o.video_index);
      if (!(i % 1 === 0 && i >= 0 && i <= 20)) return;
      // Același nod-rădăcină și aceeași numerotare ca snippetul (primul `.am-rich-description`).
      var root = document.querySelector('.am-rich-description');
      var v = root && root.querySelectorAll('video')[i];
      if (v && v.hasAttribute && v.hasAttribute('autoplay')) return;
      publica('rich_interactiune', { tip: 'video_play', valoare: String(i) });
    },
    am_rich_video_embed_play: function (o) {
      if (/^[A-Za-z0-9_-]{11}$/.test(String(o.video_id || ''))) {
        publica('rich_interactiune', { tip: 'video_embed_play', valoare: String(o.video_id) });
      }
    },
    /* Bariera de PII se aplică pe textul ORIGINAL, înainte de curățare: altfel `ion@exemplu.ro`
     * ar deveni `ion exemplu.ro` și ar trece de proxy (review Codex 13.10). */
    am_rich_details_open: function (o) {
      var brut = String(o.summary || '');
      var nfkc = brut.normalize ? brut.normalize('NFKC') : brut;
      if (nfkc.indexOf('@') !== -1 || (nfkc.match(/\p{Nd}/gu) || []).length > 8) return;
      var t = textCurat(brut, 80);
      if (t) publica('rich_interactiune', { tip: 'details_open', valoare: t });
    },
    am_rich_nav_click: function (o) {
      if (/^#[A-Za-z0-9_-]{1,40}$/.test(String(o.target || ''))) {
        publica('rich_interactiune', { tip: 'nav_click', valoare: String(o.target) });
      }
    },
    am_rich_range_click: function (o) {
      var c = caleInterna(o.href);
      if (c) publica('rich_interactiune', { tip: 'range_click', valoare: c });
    }
  };

  function atc(etapa, o) {
    var sursa = SURSE_ATC[o.sursa] ? o.sursa : null;
    // O încercare vine mereu dintr-un clic cu buton cunoscut; „necunoscut" e doar la confirmare.
    if (!sursa || (etapa === 'incercare' && sursa === 'necunoscut')) return;
    publica('atc', { etapa: etapa, sursa: sursa, brat: brat(o.am_exp_sticky) });
  }

  function proceseaza(o) {
    if (!o || typeof o !== 'object' || typeof o.event !== 'string') return;
    var f = HARTA[o.event];
    if (f) { try { f(o); } catch (err) { /* o intrare ciudată nu oprește restul */ } }
  }

  var dl = (window.dataLayer = window.dataLayer || []);
  for (var i = 0; i < dl.length; i++) proceseaza(dl[i]);
  var pushAnterior = dl.push;
  dl.push = function () {
    var r = pushAnterior.apply(dl, arguments);   // întâi efectul original (GTM, Array)
    for (var j = 0; j < arguments.length; j++) proceseaza(arguments[j]);
    return r;
  };

  // ─── Alocarea în experiment ─────────────────────────────────────────────────
  /* Din `window.amExpSticky` (pus sincron de `am-cro-experiment` în <head>), nu din intrarea
   * dataLayer: e aceeași valoare, dar nu depinde de ordinea intrărilor. `stocare` reproduce
   * read-back-ul snippetului: cookie-ul conține brațul? Altfel omul se re-randomizează între
   * pagini, iar o rată mare de „esuat" invalidează citirea experimentului. */
  (function () {
    var b = window.amExpSticky;
    if (!BRATE[b]) return;
    var ok = false;
    try { ok = new RegExp('(?:^|;\\s*)am_exp_sticky=' + b + '(?:;|$)').test(document.cookie); } catch (err) {}
    publica('exp_assign', { brat: b, stocare: ok ? 'ok' : 'esuat' });
  })();

  // ─── WhatsApp ───────────────────────────────────────────────────────────────
  /* Ordinea contează: containerul cel mai specific câștigă (bara sticky stă tot pe PDP). */
  var SUPRAFETE_WA = [
    ['.am-rich-description', 'rich'],
    ['#sticky-add-to-cart', 'sticky'],
    ['#am-openbox-ask', 'openbox'],
    ['.am-intreaba-card', 'card'],
    ['.ts-nr-wa', 'cautare'],
    ['.am-intreaba', 'pdp'],
    ['footer, .shopify-section-group-footer-group', 'subsol'],
    ['header, .shopify-section-group-header-group', 'antet']
  ];
  /* Linkurile și butoanele cu `onclick` inline. NU prinde un URL construit într-un ascultător JS
   * fără `href` (ex. callback-ul din panoul openbox, care trimite numele și telefonul — exclus
   * deliberat) — limită declarată în README. */
  var SELECTOR_WA = 'a[href*="wa.me/"], a[href*="whatsapp.com/"], a[href^="whatsapp:"], ' +
    '[onclick*="wa.me/"], [onclick*="whatsapp.com/"]';

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;   // doar clicuri reale
    var el = e.target.closest(SELECTOR_WA);
    if (!el) return;
    var suprafata = 'alt';
    for (var k = 0; k < SUPRAFETE_WA.length; k++) {
      if (el.closest(SUPRAFETE_WA[k][0])) { suprafata = SUPRAFETE_WA[k][1]; break; }
    }
    /* `.am-intreaba` (15.10.2026) are două roluri: „Cere ofertă de preț" (produs cu preț la cerere)
     * și „Verifică disponibilitatea". Le desparte textul ȘABLONULUI din temă (main-product.liquid,
     * „ofertă de preț"), url-encodat în `onclick` — nu ceva scris de client. */
    /* Și în bara sticky (review Codex 15.10): acolo `#sticky-add-to-cart` câștigă înaintea
     * `.am-intreaba`, dar un clic pe „Cere ofertă de preț” e tot o cerere de preț. */
    if ((suprafata === 'pdp' || suprafata === 'sticky') && /ofert%C4%83(?:%20|\+)de(?:%20|\+)pre/i.test(el.getAttribute && el.getAttribute('onclick') || '')) {
      suprafata = 'pret_cerere';
    }
    publica('whatsapp_click', { suprafata: suprafata, brat: brat(window.amExpSticky) });
  }, true);
})();
